/**
 * Shared HUD show/hide toggle. Persisted in localStorage; applied as a
 * `body.hud-off` class so both the classic (cl2) and modern (Three.js)
 * stylesheets can hide their respective HUD bars with one CSS rule.
 *
 * Call `applyHudVisibility()` once on entry-load (before mount) so the
 * bar never flashes on. Each HUD wires its gear button to `toggleHud`.
 */
const KEY = 'cardtoys.hud';

export function isHudOff(): boolean {
  try { return localStorage.getItem(KEY) === 'off'; } catch { return false; }
}

export function applyHudVisibility(): void {
  document.body.classList.toggle('hud-off', isHudOff());
}

export function toggleHud(): void {
  const next = isHudOff() ? 'on' : 'off';
  try { localStorage.setItem(KEY, next); } catch { /* ignore */ }
  applyHudVisibility();
}
